module.exports = __webpack_public_path__ + "img/webcam-icon.11b7bce7.svg";